import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { SMARTCA_SETTINGS_URL, type SigningService } from '../lib/signingService';
import { Callout } from './blocks';

/**
 * What stops the registrar's signature, in plain words, with the way to the settings: SmartCA
 * chosen but not configured, signing switched off, or the test signer (local development only).
 * Nothing when SmartCA is ready (or its state cannot be read).
 */
export function SigningServiceNotice({ service }: { service: SigningService | null }) {
  const { t } = useTranslation('compliance');
  if (!service?.signer) return null;
  const link = (
    <Link to={SMARTCA_SETTINGS_URL} className="font-medium text-primary underline-offset-2 hover:underline">
      {t('signature.notice.open')}
    </Link>
  );
  if (service.signer === 'SMARTCA' && service.configured === false) {
    return (
      <div data-signing-notice="not-configured">
        <Callout tone="warn">
          {t('signature.notice.notConfigured')} — {link}
        </Callout>
      </div>
    );
  }
  if (service.signer === 'OFF') {
    return (
      <div data-signing-notice="off">
        <Callout tone="warn">
          {t('signature.notice.off')} — {link}
        </Callout>
      </div>
    );
  }
  if (service.signer === 'MOCK') {
    return (
      <div data-signing-notice="mock">
        <Callout tone="warn">
          {t('signature.notice.mock')} — {link}
        </Callout>
      </div>
    );
  }
  return null;
}
